var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarninginline = function SvgWarninginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A52834",
    fillRule: "evenodd",
    d: "M13.973 2.349a1.695 1.695 0 0 0-2.94 0L.747 19.849c-.685 1.167.137 2.65 1.47 2.65h20.57c1.334 0 2.157-1.484 1.47-2.65L13.973 2.35ZM12.5 7.499a1.357 1.357 0 0 0-1.35 1.493l.525 5.26a.828.828 0 0 0 1.65 0l.525-5.26A1.358 1.358 0 0 0 12.5 7.5Zm.003 9a1.5 1.5 0 1 0 0 3.001 1.5 1.5 0 0 0 0-3Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h24v24H.5z"
  })))));
};

export default SvgWarninginline;